<template>
    <div>
        <div id="navigationPlaceholder" style="padding-top: 80px;">
            <AdminNavigationV2 :tid="organizationUnitId"></AdminNavigationV2>
        </div>

        <div class="container">
            <div class="row">
                <div class="col-lg-7">
                    <h1 style="font-size: 2em; font-weight: 300; color: #33475b;">Manage user's organization</h1>

                    <a href="/#/admin/organizations/manage" class="btn btn-link btn-sm">
                        <i class="fa fa-arrow-left" aria-hidden="true"></i>
                        <span>Back</span>
                    </a>
                </div>
            </div>
        </div>

        <hr style="border-color: #bbb; margin: 20px 0 30px;" />

        <div v-if="id && user" class="container">
            <h4 class="fg-color-blue">{{displayName}} belongs to organization {{organizationUnitName}}</h4>
            <br />

            <table class="table table-striped table-hover">
                <tbody>
                    <tr v-for="ou in organizationUnits">
                        <th>{{ou.Name}}</th>
                        <td>
                            <span v-if="ou.OrganizationUnitId==organizationUnitId">
                                <i class="fa fa-check-circle fg-color-green" aria-hidden="true"></i>
                                Current
                            </span>
                            <button v-else @click="handleChangeOrganizationUnitCommandV1(ou)"
                                    type="button" class="btn btn-sm btn-primary">
                                Move to
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div v-else-if="!id" class="container">
            <div class="input-group mb-3">
                <input v-model="emailinput" type="email" class="form-control" placeholder="Find user by email">
                <div class="input-group-append">
                    <button @click="handleFindUser" class="btn btn-outline-secondary" type="button">Find</button>
                </div>
            </div>
        </div>

        <div v-else class="container">
            <h4>Email '{{id}}' not found</h4>
        </div>
    </div>
</template>

<script lang="ts">
    import { Component, mixins } from 'vue-facing-decorator';
    import PageBase from "@common/PageBase";
    import Queries from "@Organizations/Users/queries-vue-component";
    import OrganizationUnitsQueries from "@Organizations/OrganizationUnits/queries-vue-component";
    import Commands from "@Organizations/Users/commands-vue-component";
    import "@common/AdminNavigationV2.vue";

    @Component
    export default class ManageUserOrganizationPage extends mixins(PageBase, Queries, OrganizationUnitsQueries, Commands) {
        mounted() {
            this.setTitle("Manage user's organization");

            if (this.id) {
                this.runUserQueryV1(this.id);
            }

            this.runOrganizationUnitsQueryV1();
        }

        emailinput = '';

        get userWithSensitiveData() { return this.model?.UserWithSensitiveData; }
        get organizationUnitsList() { return this.model?.OrganizationUnitsList; }

        get user() { return this.userWithSensitiveData; }
        get email() { return this.user?.Email; }
        get displayName() { return this.user?.DisplayName; }
        get organizationUnitId() { return this.user?.OrganizationUnitId; }

        get organizationUnits() { return this.organizationUnitsList?.OrganizationUnits || []; }
        get organizationUnit() { return this.organizationUnits.find(_ => _.OrganizationUnitId == this.organizationUnitId) }
        get organizationUnitName() { return this.organizationUnit?.Name }

        succeedAnyCommand() {
            this.runUserQueryV1(this.id);
        }

        handleChangeOrganizationUnitCommandV1(ou) {
            if (confirm(`Do you really want to change user ${this.email} organization to ${ou.Name}?`))
                this.invokeChangeOrganizationUnitCommandV1(this.id, ou.OrganizationUnitId);
        }

        handleFindUser() {
            this.navigateTo(`/#/admin/organizations/users/manage/organization/${this.emailinput}`);
        }
    }
</script>

<style scoped>
</style>